export var OPTION_CHAINTOOL = "OPTION_CHAINTOOL";
export var OPTION_CHAINTOOL_ERROR = "OPTION_CHAINTOOL_ERROR";
export var OPTION_CHAINTOOL_HIDE_ERROR = "OPTION_CHAINTOOL_HIDE_ERROR";
export var OPTION_CHAINTOOL_START_LOADER = "OPTION_CHAINTOOL_START_LOADER";
export var OPTION_CHAINTOOL_STOP_LOADER = "OPTION_CHAINTOOL_STOP_LOADER";
export var OPTION_CHAINTOOL_EXPIRY_DATE_DATA = "OPTION_CHAINTOOL_EXPIRY_DATE_DATA";
